// extracted by mini-css-extract-plugin
module.exports = {"root":"n_p0","wrapper":"n_p1","image":"n_p2 h_dp h_dr h_dP","crop":"n_p3","round":"n_p4","fixedHeight":"n_p5"};